// extracted by mini-css-extract-plugin
export default {"Star":"📚19-10-2rKuyo"};